import React from 'react';
import RadioGroup from 'src/shared/components/radio-group/RadioGroup';

type MapTypeProps = {
    handleChange: (value: string) => void;
    value: string;
    hasSubscribed?: boolean;
};

export const mapTypes = [
    { label: 'Default', value: 'roadmap' },
    { label: 'Terrain', value: 'terrain' },
    { label: 'Satellite', value: 'satellite' },
];

const MapType = ({ handleChange, value }: MapTypeProps) => {
    return (
        <div className='flex flex-col gap-1'>
            <RadioGroup options={mapTypes} onChange={value => handleChange(value as string)} selectedOption={value} />
        </div>
    );
};

export default MapType;
